import React, { FC } from 'react';
import { useWatch } from 'react-hook-form';

import { ComponentSection } from 'models';

import { ComponentImagesField } from 'components/component-fields/ComponentImagesField';
import { DatasheetMode, useDatasheetMode } from 'components/datasheet/DatasheetMode';

import { ComponentDatasheetSectionProgress } from '../ComponentDatasheetSectionProgress';
import { ComponentDatasheetSection } from './ComponentDatasheetSection';

const Images: FC = () => {
    const mode = useDatasheetMode();

    const editMode = mode !== DatasheetMode.VIEW;

    const [images = []] = useWatch({ name: ['images'] });
    const hasImages = !!images?.length;

    if (!hasImages && !editMode) return null;

    return (
        <ComponentDatasheetSection
            title="Images"
            id={ComponentSection.IMAGES}
            afterTitle={<ComponentDatasheetSectionProgress section={ComponentSection.IMAGES} />}
        >
            <ComponentImagesField columns={{ base: 2, sm: 4 }} editable={editMode} />
        </ComponentDatasheetSection>
    );
};

export { Images };
